<template>
    <div class="Experience">  
        <Ribbon/>
        <Weave v-if="$route.params.section == undefined 
                  || $route.params.section == 'weave'
                  || $route.params.section == 'recenter'"/>
        <Story v-if="isAfter($route.params.section, 'weave') && $route.params.section != 'support'"/>
        <Support v-if="use_support"/>
        <AudioComp/>
    </div>
</template>

<script>

import gsap from "gsap"
import Support from '@/components/Support.vue'
import Story from '@/components/Story.vue'
import Weave from '@/components/Weave.vue'
import Ribbon from '@/components/Ribbon.vue'
import AudioComp from '@/components/assets/AudioComp.vue'

export default {
    name: 'Experience',
    components: { Weave, Ribbon, Story, Support, AudioComp },
    data:()=>({
        use_support: false,
        initialized: false
    }),
    computed: {
        status() { return this.$store.getters['app/status'] },
    },
    watch: {
        status(nw) {
            if(nw == 'init')
                gsap.delayedCall(1, ()=> this.use_support = true)
        },  
        '$route': {
            immediate: true,
            handler() {
                if(this.initialized == false) {
                    const cnd = this.$root.route.from.params.section == this.$root.route.from.params.section && this.$root.route.from.params.section != undefined
                    if(cnd) {
                        this.initialized = true
                        this.$router.push({ params: { section: undefined, step: undefined } })
                    }
                }
                this.initialized = true
            }
        }
    },
    methods: {
        isAfter(c1, c2) {
            const cues = [ 'weave', 'story', 'voice', 'record', 'words', 'share', 'finish', 'support' ]
            if(c1 == undefined)
                return false
            return cues.indexOf(c1) > cues.indexOf(c2) ? true : false
        },
    }
}
</script>

<style lang="stylus">

@import '~@/config/Settings'
@import '~@/commons/stylus/Media-queries'

.Experience
    display block
    position absolute
    top 0
    left 0 
    width 100%
    height 100%
    color purple

</style>


